// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3ivsv","vLegacy":"SelectSecondary_vLegacy__2cPcf","error":"SelectSecondary_error__3bDAs","disabled":"SelectSecondary_disabled__2rfHH"};